<template>
  <div class="tactics">
    <div v-if="list&&list.length">
      <div
        v-for="(item,index) in list"
        :key="index"
        class="tactics_content"
      >
        <span class="tip_text">当订单到达时，满足以下条件<span
          class="deleta_btn"
          @click="handleAllDelete(index)"
        >删除</span></span>
        <div v-for="(child,i) in item.projectReqs" :key="i">
          <el-form-item
            :label="i===0?'运营项目':' '"
            label-width="112px"
            class="project_form_item"
          >
            <div class="contract_content">
              <el-select
                v-model="child.projectId"
                clearable
                filterable
                placeholder="请选择原始货主对应的项目"
                @change="(val) => changeProject(val,index,i)"
              >
                <el-option
                  v-for="pro in projectList(i)"
                  :key="pro.id"
                  :disabled="isDisabled(item.projectReqs,pro.id)"
                  :label="pro.label"
                  :value="pro.id+''"
                >
                  <div class="project-select">
                    <span class="line">{{ pro.name }}</span>
                  </div>
                </el-option>
              </el-select>
              <div class="active_bar">
                <span
                  v-if="item.projectReqs.length===i+1&&item.projectReqs.length<5"
                  class="add_btn btn"
                  @click="handleProjectAdd(index,'projectReqs')"
                />
                <span
                  v-if="item.projectReqs.length!==1"
                  class="minus_btn btn"
                  @click="handleProjectDelete(index,i,'projectReqs')"
                />
              </div>
            </div>
          </el-form-item>
        </div>
        <div>
          <span class="tip_text">执行一下动作</span>
          <el-form-item
            label="计费方式"
            label-width="112px"
            class="project_form_item"
            :prop="`${validateString}.${index}.chargeType`"
            :rules="TACTICS_RULES.CONDITION"
          >
            <el-select
              :ref="`chargeType-${index}`"
              v-model="item.chargeType"
              clearable
              filterable
              placeholder="请选择计费方式"
              @change="onChargeTypeChange($event, index)"
            >
              <el-option
                v-for="obj in CONTRACT_CHARGE_TYPE"
                :key="obj.value"
                :label="obj.label"
                :value="obj.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="item.chargeType === 'CONTRACT_PRICE'"
            label="计费条款"
            label-width="112px"
            class="project_form_item"
            :prop="`${validateString}.${index}.contractTermCodes`"
            :rules="TACTICS_RULES.CONDITION"
          >
            <el-cascader
              :ref="`copeWithTerm-${index}`"
              v-model="item.contractTermCodes"
              :options="copeWithTerm"
              placeholder="请输入合同或条款关键字搜索"
              filterable
              clearable
              popper-class="billing-cascader"
              @change="(val) => changeCopeWithTerms(val,index)"
            />
          </el-form-item>
          <el-form-item
            v-if="item.chargeType === 'FREQUENCY_PRICE'"
            label="趟次计算周期"
            label-width="112px"
            class="project_form_item"
            :prop="`${validateString}.${index}.frequencyDateConfig`"
            :rules="TACTICS_RULES.FREQUENCY_NUMBER"
          >
            <div class="frequency-wrapper">
              <el-time-picker
                v-model="item.frequencyDateConfig.startTime"
                format="HH:mm"
                value-format="HH:mm"
                range-separator="至"
                start-placeholder="开始"
                end-placeholder="结束"
              />
              <div class="split">
                间隔 <el-input-number v-model="item.frequencyDateConfig.intervalDays" :min="0" />天
              </div>
              <el-time-picker
                v-model="item.frequencyDateConfig.endTime"
                format="HH:mm"
                value-format="HH:mm"
                range-separator="至"
                start-placeholder="开始"
                end-placeholder="结束"
              />
            </div>
          </el-form-item>
        </div>
      </div>
    </div>
    <div v-if="list.length<20" class="item">
      <div class="addOrCondition_btn flex flex-center" @click="handleAdd">
        <span>
          <i class="el-icon-plus" />
          {{ '添加计费策略' }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { pricingScene } from '@/views/shipper/shipperCreate/constant';
import { getContractList, fetchProject } from '@/api/shipper';
import { TACTICS_RULES, CONTRACT_CHARGE_TYPE } from './const';

export default {
  name: 'Tactics',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    validateString: {
      type: String,
      default: '',
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      CONTRACT_CHARGE_TYPE,
      TACTICS_RULES,
      copeWithTerm: [],
      projectData: [],
    };
  },
  computed: {
    filterContractData() {
      return (data) => data.map((item) => ({
        ...item,
        children: item.children.map((child) => ({
          ...child,
          disabled: this.form.contractReqs.some((contract) => contract.termCode === child.value)
        })),
      }));
    },
    isDisabled() {
      return (projectReqs, id) => projectReqs.some((item) => Number(item.projectId) === id);
    },
    projectList() {
      return (childIndex) => {
        const list = JSON.parse(JSON.stringify(this.projectData));
        return childIndex ? list : [{ id: '', name: '不限运营项目', label: '不限运营项目' }, ...list];
      };
    },
  },
  mounted() {
    this.getTurnProjectList();
    this.getOrderTerm();
  },
  methods: {
    getOrderTerm() {
      const getTermsList = this.getContractList({
        cargoOwnerCode: this.customersDetail.customerCode,
        pricingScene: pricingScene.pay,
        partBTenantId: this.customersDetail.carrierTenantId,
      });
      getTermsList.then((res) => {
        this.copeWithTerm = res;
      });
    },
    changeCopeWithTerms(val, index) {
      if (val && val.length) {
        // 当有值时，把合同及条款名称找出
        const ref = `copeWithTerm-${index}`;
        const res = this.$refs[ref][0].getCheckedNodes();
        this.getContract(res[0].parent, res[0], index);
      } else {
        const data = {
          ...this.list[index],
          contractTermCodes: [],
          contractReq: {
            contractCode: '',
            contractName: '',
            termCode: '',
            termName: '',
          },
        };
        this.$set(this.list, index, data);
      }
    },
    getContract(parentNode, node, index = '') {
      const data = {
        ...this.list[index],
        contractReq: {
          contractCode: parentNode.value,
          contractName: parentNode.label,
          termCode: node.value,
          termName: node.label,
        },
      };
      this.$set(this.list, index, data);
    },
    async getContractList(params) {
      const contractList = await getContractList({
        ...params,
        needAllContracts: true,
        statuses: ['ENABLED', 'DISABLED'],
        needOtherState: true,
      });
      const termsList = [];
      contractList.forEach((v) => {
        const label = v.contractName;
        const value = v.contractCode;
        const currentTime = new Date().getTime();
        const disabled = v.status === 'DISABLED' || currentTime > v.closeTime;
        termsList.push({
          label,
          value,
          disabled,
          children: v.contractCode ? this.getTermsList(v.contractTermInfo) : undefined,
        });
      });
      return termsList;
    },
    getTermsList(records) {
      const terms = records.map((v) => {
        const label = v.name;
        const value = v.code;
        const currentTime = new Date().getTime();
        const disabled = v.status === 'DISABLED' || currentTime > v.closeTime;
        return {
          label,
          value,
          disabled,
        };
      });
      return terms;
    },
    changeProject(val, index, childIndex) {
      if (val) {
        const current = this.projectData.find((item) => `${item.id}` === val);
        this.list[index].projectReqs[childIndex].projectName = current.name;
      } else {
        this.$set(this.list[index].projectReqs, childIndex, {
          projectId: '',
          projectName: '',
        });
      }
    },
    async getTurnProjectList() {
      const res = await fetchProject({
        customerCode: this.customersDetail.customerCode,
        parentIdentityId: this.customersDetail.id,
        type: 'PROJECT',
        status: 'ENABLE',
      });
      const list = [];
      if (res && res.records) {
        const oldList = res.records.map((t) => ({
          ...t,
          name: t.name || t.projectName,
          code: t.code || t.projectCode,
        }));
        oldList.forEach((item) => {
          const label = item.name;
          const termName = '';
          list.push({
            ...item,
            label,
            termName,
          });
        });
      }
      // this.projectData = list;
      this.$set(this, 'projectData', list);
    },
    verifyProjectAdd(data) {
      let res = true;
      try {
        data.forEach((item) => {
          if (!item.projectId) {
            throw new Error('End');
          }
        });
      } catch (error) {
        res = false;
      }
      return res;
    },
    handleAdd() {
      this.$emit('addTactics');
    },
    handleProjectAdd(index, prop) {
      if (!this.verifyProjectAdd(this.list[index].projectReqs)) return;
      this.$emit('addTacticsProject', index, prop);
    },
    handleProjectDelete(index, childIndex, prop) {
      this.$emit('deleteTacticsProject', index, childIndex, prop);
    },
    handleAllDelete(index) {
      this.list.splice(index, 1);
    },
    onChargeTypeChange(type, index) {
      if (type === 'TAXIMETER_PRICE') { // 计价器计费
        const data = {
          ...this.list[index],
          contractTermCodes: [],
          contractReq: {
            contractCode: '',
            contractName: '',
            termCode: '',
            termName: '',
          },
          frequencyDateConfig: { }
        };
        this.$set(this.list, index, data);
      } else if (type === 'CONTRACT_PRICE') { // 合同计费
        const data = {
          ...this.list[index],
          frequencyDateConfig: { }
        };
        this.$set(this.list, index, data);
      } else if (type === 'FREQUENCY_PRICE') { // 按趟次计费
        const data = {
          ...this.list[index],
          contractTermCodes: [],
          contractReq: {
            contractCode: '',
            contractName: '',
            termCode: '',
            termName: '',
          },
        };
        this.$set(this.list, index, data);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.tactics{
  margin-bottom: 24px;
}
.addOrCondition_btn{
  cursor: pointer;
  height: 38px;
  border: 1px dashed #B3B7BE;
  font-size: 14px;
  .el-icon-plus{
    margin-right: 10px;
  }
  &:hover{
    border-color: #51CDA6;
    color: #51CDA6;
  }
  &:focus{
    border-color: #059366;
    color: #059366;
  }
}
::v-deep .project_form_item{
  margin-bottom: 8px;
  display: flex;
  .el-form-item__label{
    line-height: 32px !important;
    width: 112px;
    text-align: right;
    margin-right: 8px;
    padding-bottom: 0px;
  }
  .el-form-item__content{
    width: 100%;
  }
  .el-select,.el-cascader {
    width: 30%;
  }
}
.tactics_content{
  background-color: #FAFAFB;
  padding: 16px;
  margin-bottom: 24px;
}
.contract_content{
  display: flex;
  align-items: center;
  .active_bar{
      width: 60px;
      display: flex;
      height: 20px;
      margin-left: 10px;
     .btn{
        width: 20px;
        height: 20px;
        display: inline-block;
        cursor: pointer;
        margin-right: 8px;
      }
    .add_btn{
      background-image: url('../../../../assets/img/add_icon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      &:hover{
        background-image: url('../../../../assets/img/add_icon_hover.png');
      }
    }
    .minus_btn{
      background-image: url('../../../../assets/img/remove_icon.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 0px;
      &:hover{
        background-image: url('../../../../assets/img/remove-icon_hover.png');
      }
    }
  }
}
.tip_text{
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: #404B5C;
  font-size: 14px;
  margin-bottom: 16px;
  .deleta_btn{
    color: #059E84;
    font-size: 14px;
    cursor: pointer;
  }
}
.frequency-wrapper {
  display: flex;
  align-items: center;
  .split {
    margin: 0 8px;
    display: flex;
    gap: 4px;
  }
}
</style>
